import angular from 'angular';

import { TrabalhadoresLocadosIndexController } from './index/trabalhadoreslocados.index.controller';
import { TrabalhadorLocadoShowController } from './show/trabalhadorlocado.show';

import { TrabalhadoresLocadosService } from './trabalhadoreslocados.service';

import { TrabalhadoresLocadosListRouting } from './trabalhadoreslocados.routes';

export const TrabalhadoresLocadosModule = angular.module('TrabalhadoresLocadosModule', ['ui.router.state'])
    .controller('TrabalhadoresLocadosIndexController', TrabalhadoresLocadosIndexController)
    .controller('TrabalhadorLocadoShowController', TrabalhadorLocadoShowController)
    .service('TrabalhadoresLocadosService', TrabalhadoresLocadosService)
    .config(TrabalhadoresLocadosListRouting)
    .name;
